<template>
    <div class="flex w-full justify-between items-center py-0.5 bg-gray-100">
        <button
            class="w-full h-10 flex tracking-wider font-medium justify-start text-start items-center whitespace-pre-wrap px-2 border border-dark-secondary hover:bg-dark-primary text-dark-secondary hover:text-white rounded"
            @click="showBulkActionMenu"
        >
            {{ bulkOperation.label }}
        </button>
        <div class="flex">
            <slot name="dragButton"></slot>
            <slot name="button" class="cursor-pointer"></slot>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';


const props = defineProps([
    'bulkOperationKey',
    'bulkOperation'
])

const emit = defineEmits([
    'show-bulk-action-menu'
])


function showBulkActionMenu() {
    // console.log('showBulkActionMenu', props.bulkOperationKey, props.bulkOperation)
    emit('show-bulk-action-menu', props.bulkOperationKey, props.bulkOperation)
}
</script>